"use strict";

const PriceType = {
  ADR: "ADR",
  ADW: "ADW",
  RTL: "RTL",
  WHL: "WHL",

  PTS: "PTS",

  WADR: "WADR",
  WADW: "WADW",
  WADWD: "WADWD",
  WRTL: "WRTL",
  WWHL: "WWHL"
};

module.exports = PriceType;
